module.exports = __webpack_public_path__ + "img/smooth_scotland.866640f8.png";